import { render, staticRenderFns } from "./terms-dec29.vue?vue&type=template&id=0fac48ec&scoped=true&"
import script from "./terms-dec29.vue?vue&type=script&lang=js&"
export * from "./terms-dec29.vue?vue&type=script&lang=js&"
import style0 from "./terms-dec29.vue?vue&type=style&index=0&id=0fac48ec&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fac48ec",
  null
  
)

export default component.exports